import { usePartDefinition } from "@project/emerge";
import type { SupplyPartDefinition } from "@project/emerge-types";
import { DoubleSide } from "three";
import { LTPartType } from "../enum/PartType";
import type { CutoutSelection } from "../structure/cutoutSelection";

type CutoutPart = SupplyPartDefinition<LTPartType.Cutout, CutoutSelection>;

/**
 * Grab surface for an Ausschnitt. The hole itself is cut into the panel; this
 * plane only gives the pointer something to drag. It sits a millimetre outside
 * the panel, in the same local frame as the other addables (up = +Y).
 */
export const CutoutRenderer = ({ id }: { id: string }) => {
  const partDef = usePartDefinition<CutoutPart>({
    id,
    select: ["partSelection"],
  });
  const width = partDef?.partSelection.width ?? 0;
  const height = partDef?.partSelection.height ?? 0;
  if (width <= 0 || height <= 0) return null;

  return (
    <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 1, 0]}>
      <planeGeometry args={[width, height]} />
      <meshBasicMaterial
        transparent
        opacity={0}
        depthWrite={false}
        side={DoubleSide}
      />
    </mesh>
  );
};
